import { Koi } from '@ksyos/koi';
import { PractitionerRole } from '@common/enums/practitionerRole';
import type { ISchemaContainer } from './schemaContainer';

export interface IEmploymentRoleAddEditValidated {
    deactivate: boolean;
    practitionerRole: PractitionerRole;
}

export const employmentRoleAddEditSchema: ISchemaContainer<IEmploymentRoleAddEditValidated> = {
    schema: Koi.object({
        deactivate: Koi.boolean(),
        practitionerRole: Koi.koi().enum(PractitionerRole),
    }).options({ convert: false, presence: 'required' }),
};
